import {
  Form,
  Input,
  notification,
  message,
  InputNumber,
  DatePicker,
  TimePicker,
} from "antd";
import FormItem from "antd/lib/form/FormItem";
import { Formik } from "formik";
import { observer } from "mobx-react-lite";
import React, { createContext, useContext } from "react";
import MaterialStore from "../store/materialstore";
import * as yup from "yup";
import { toJS } from "mobx";
import "../style/addchemical.css";
import TextArea from "antd/lib/input/TextArea";
import formatNumber from "accounting-js/lib/formatNumber";
import Modal from "antd/lib/modal/Modal";
import moment from "moment";
import { getCurrentUser } from "../../../Utility/modules/helpers";
import { getPickerDate, getPickerMoment } from "../../../Utility/modules/datePicker";
import confirm from "antd/lib/modal/confirm";
const materialStoreCtx = createContext(MaterialStore);
const _ = require("underscore");
export const validationSchema = yup.object().shape({
  change: yup.number().required("Please enter a valid quantity"),
  changeDate: yup.date().required("Enter restock date"),
});
export const StockHistoryForm = observer(() => {
  const materialStore = useContext(materialStoreCtx);
  return (
    <>
      <Modal
        title={`Restock ${materialStore.mainStore.assetContextName}'s  ${materialStore.selChem?.name}`}
        centered
        visible={materialStore.showStockDialog}
        okText="OK"
        okButtonProps={{
          //loading: materialStore.savingHistory,
          htmlType: "submit",
        }}
        cancelButtonProps={{ type: "link" }}
        onOk={async () => {
          confirm({
            title: `Confirm chemical restocking records?`,
            content: (
              <span style={{ color: "red" }}>
                for audit purpose,this operation cannot be reversed
              </span>
            ),
            okText: "Restock",
            okType: "primary",
            okButtonProps: {
              loading: materialStore.savingHistory,
              htmlType: "submit",
            },
            cancelText: "Cancel",
            onOk: async () => {
              try {
                let { stockData } = toJS(materialStore);
                let { chemicalId } = materialStore.selChem;
                let formData = {
                  ...toJS(stockData),
                  assetId: materialStore.mainStore.assetContextId,
                  chemicalId,
                  currentStock: materialStore.selChem?.stock,
                  uploadedBy: getCurrentUser()?.fullName,
                  uploadedOn: new Date(),
                };
                if (!_.isDate(formData.changeDate) || formData.change === 0) {
                  notification.info({
                    message: "SPARS Feedback",
                    description: "Fill the required fields with red asteriks",
                  });
                  return;
                }
                await materialStore.restock(formData);

                materialStore.showStockDialog = false;
                message.success(
                  `${materialStore.selChem?.name} chemical restocked successfully`
                );
              } catch (error) {
                notification.error({
                  key: "error",
                  message: "SPARS Feedback",
                  description: error.message,
                });
              } finally {
                materialStore.savingHistory = false;
              }
            },
            onCancel() {},
          });
        }}
        onCancel={() => {
          materialStore.showStockDialog = false;
        }}
        destroyOnClose={true}
        width={600}
      >
        <Formik
          enableReinitialize={true}
          initialValues={toJS(materialStore.stockData)}
          validationSchema={validationSchema}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            setFieldValue,
            handleSubmit,
            isSubmitting,
          }) => (
            <Form
              layout="vertical"
              labelAlign="left"
              style={{ background: "#fff", padding: "10px" }}
              onFinish={handleSubmit}
            >
              <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm6">
                    <FormItem
                      label={`Restock Quantity (${materialStore.selChem?.unit})`}
                      labelAlign="left"
                      help={touched.change && errors.change}
                      required
                    >
                      <InputNumber
                        style={{ minWidth: "70%" }}
                        name="stock"
                        value={values?.change}
                        onChange={(value) => {
                          materialStore.stockData.change = value;
                          setFieldValue("change", value);
                        }}
                      />
                    </FormItem>
                  </div>
                  <div className="ms-Grid-col ms-sm6">
                    <FormItem label="Restock Cost (NGN)" labelAlign="left">
                      <InputNumber
                        min={0}
                        style={{ minWidth: "70%" }}
                        name="stock"
                        value={values?.cost}
                        onChange={(value) => {
                          materialStore.stockData.cost = value;
                          setFieldValue("cost", value);
                        }}
                      />
                    </FormItem>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm6">
                    <FormItem
                      label="Restock Date "
                      labelAlign="left"
                      required
                      help={touched.change && errors.change}
                    >
                      <DatePicker
                        onChange={(date, dateString) => {
                          if (date) {
                            const changeDate = getPickerDate(date);
                            materialStore.stockData.changeDate = changeDate;
                            setFieldValue("changeDate", getPickerMoment(date));
                          }
                          console.log(date, dateString);
                        }}
                      />
                    </FormItem>
                  </div>
                  <div className="ms-Grid-col ms-sm6">
                    <FormItem label="Time (Period)" labelAlign="left">
                      <TimePicker
                        format={"HH:mm"}
                        onChange={(date) => {
                          if (date) {
                            const time = moment(date).format("HH:mma");
                            materialStore.stockData.restockTime = time;
                            setFieldValue("restockTime", time);
                          }
                        }}
                      />
                    </FormItem>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm6">
                    <FormItem label="Action Party" labelAlign="left">
                      <Input
                        name="restockParty"
                        value={values?.restockParty}
                        onChange={({ target }) => {
                          const { value } = target;
                          materialStore.stockData.restockParty = value;
                          setFieldValue("restockParty", value);
                        }}
                      />
                    </FormItem>
                  </div>
                  <div className="ms-Grid-col ms-sm6">
                    <FormItem label="Approved Party" labelAlign="left">
                      <Input
                        name="approvedParty"
                        value={values?.approvedParty}
                        onChange={({ target }) => {
                          const { value } = target;
                          materialStore.stockData.approvedParty = value;
                          setFieldValue("approvedParty", value);
                        }}
                      />
                    </FormItem>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12">
                    <FormItem label="Vendor/Supplier" labelAlign="left">
                      <Input
                        name="vendor"
                        value={values?.vendor}
                        onChange={({ target }) => {
                          const { value } = target;
                          materialStore.stockData.vendor = value;
                          setFieldValue("vendor", value);
                        }}
                      />
                    </FormItem>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12">
                    Current Stock:{" "}
                    <span style={{ color: "red" }}>
                      {" "}
                      {formatNumber(materialStore.selChem?.stock, {
                        precision: 2,
                        thousand: ",",
                      })}{" "}
                      {materialStore.selChem?.unitAbbr}
                    </span>{" "}
                  </div>
                </div>
                <div className="ms-Grid-row" style={{ marginTop: "5px" }}>
                  <div className="ms-Grid-col ms-sm12">
                    New Stock:{" "}
                    <div className="pill">
                      <span
                        style={{
                          color: "blue",
                          fontSize: "11px",
                        }}
                      >
                        {formatNumber(materialStore.newStockValue, {
                          precision: 2,
                          thousand: ",",
                        })}{" "}
                        {materialStore.selChem?.unitAbbr}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12">
                    <FormItem label="Remarks" labelAlign="left">
                      <TextArea
                        rows={5}
                        name="remarks"
                        value={values?.remarks}
                        onChange={({ target }) => {
                          const { value } = target;
                          materialStore.stockData.remarks = value;
                          setFieldValue("remarks", value);
                        }}
                      />
                    </FormItem>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
});

